import { Components, Theme } from '@mui/material';

export const MuiTablePagination: Components<Omit<Theme, 'components'>> = {};
